<!--
Copyright (c) 2020 GanttProject Cloud OU.
Author: Dmitry Barashev (dbarashev@ganttproject.cloud)
-->
<template>
    <div class="modal fade" id="modal-leave-team" tabindex="-1" role="dialog"
         aria-labelledby="modal-leave-team-title" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">

            <div class="modal-content" @keydown="leaveTeamApplyShortcut">
                <div class="modal-body">
                    <div class="d-flex align-items-center">
                        <i class="fa fa-exclamation-circle fa-3x"></i>
                        <p class="m-0 ml-2">You are going to leave the team. You will have to contact team owner if you decide to get back.</p>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary btn-cancel" data-dismiss="modal" tabindex="1">Cancel</button>
                    <button type="button" class="btn btn-danger" @click="leaveTeam" tabindex="2">Yes, leave this team</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Component, Prop, Vue} from 'vue-facing-decorator';
import {handleXhrError, ShortcutHandler} from '../utils/Ui';
import {TeamExpel} from '../Routes';
import {TeamDto} from '../Teams';
import BtnSubmit from './BtnSubmit.vue';
import * as Auth from '../auth/Auth';

import $ from 'jquery';

@Component({
  components: {BtnSubmit},
})
export default class TeamLeaveModal extends Vue {

  @Prop()
  public dashboardRefresh: () => void;

  @Prop()
  public team: TeamDto;
  private shortcutHandler = new ShortcutHandler();

  public mounted() {
    this.shortcutHandler.register('Enter', this.leaveTeam);
  }

  public leaveTeam() {
    TeamExpel.invoke({ teamRefid: this.team!.refid, userId: Auth.getUser().id() })
        .done(() => {
          this.hide();
          this.dashboardRefresh();
        })
        .fail((jqXhr) => {
          handleXhrError(jqXhr, 'can\'t leave team');
        });
  }

  private leaveTeamApplyShortcut(e: KeyboardEvent) {
    this.shortcutHandler.handle(e);
  }

  private hide() {
    $('#modal-leave-team').modal('hide');
  }
}
</script>
